

















































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  accessList,
  getAccessInfo,
  saveModuleInfo,
  deletePayApp
} from '@/api/payment/payment'

@Component({
  name: 'accessModule'
})
export default class extends Vue {
  tableData: any[] = []
  moreOption: string = ''
  pageInfo: any = {
    page: 1,
    pageCount: 10
  }
  editVisible: boolean = false
  editParams: any = {
    id: 0,
    name: '',
    description: '',
    allow_pay: 0
  }

  totalCount: number = 0

  tableHeight: number = 500

  selectReverse() {}

  selectAll() {
    console.log('selectAll')
  }

  handleSelectionChange() {}

  handleDelete({ id }: any) {
    this.$confirm('是否删除？/ 批量删除吗？', '提示', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deletePayApp({ id })
        if (+res.status.code === 0) {
          this.$message.success('操作成功')
          await this.getTableData()
        } else {
          this.$message.warning(res.status.message)
        }
      })
      .catch(() => {})
  }

  async handleSwitch(row: any) {
    this.editParams.id = row.id
    this.editParams.name = row.name
    this.editParams.allow_pay = row.allow_pay
    await this.handleSave()
    this.$message.success('操作成功')
  }

  async handleEdit({ id }: any) {
    let res: any = await getAccessInfo({ id })
    let { description, name } = res.data
    this.editParams = { id, description, name, allow_pay: res.data['allow_pay'] }
    this.handleAdd(id)
  }

  async handleSave() {
    this.editParams.name = this.editParams.name.trim()
    if (this.editParams.name.length <= 0) return this.$message.warning('请输入支付通道名称')
    let res: any = await saveModuleInfo(this.editParams)
    if (~~res.status.code === 0) {
      this.editVisible = false
      this.getTableData()
    }
  }

  handleAdd(id: number) {
    if (id <= 0) {
      this.editParams = {
        id,
        name: '',
        description: '',
        allow_pay: 0
      }
    }
    this.editVisible = true
  }

  async getTableData() {
    let res: any = await accessList(this.pageInfo)
    this.tableData = res.data.dataList || []
    this.totalCount = +res.data.pageInfo.totalCount
  }

  setTableHeight() {
    this.tableHeight = document.body.clientHeight - 280
  }

  created() {
    this.getTableData()
  }

  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }

  get moreOptions() {
    return []
  }
}
